<template>
  <div id="hot-14j0b5t" class="handsontable">
    <div class="ht_master handsontable">
      <hot-table
        ref="hotTableComponent1"
        :width="width"
        :colWidths="colWidths"
        :height="height"
        :data="tb1"
        :mergeCells="mergeCells1"
        :cell="cell1"
        :licenseKey="licenseKey"
      ></hot-table>
      <table class="htCore" style="margin: auto">
        <colgroup>
          <col class="rowHeader" style="width: 200px" />
          <col style="width: 150px" />
          <col style="width: 150px" />
          <col style="width: 150px" />
          <col style="width: 150px" />
          <col style="width: 150px" />
          <col style="width: 150px" />
        </colgroup>
        <thead></thead>
        <tbody>
          <tr>
            <td class="htCenter htDimmed" rowspan="1" colspan="7">
              工业总产值（当年价格）
              <div style="float: right">
                <el-button
                  style="padding: 0px"
                  type="text"
                  size="mini"
                  :disabled="loading"
                  @click="addZcz"
                  >添加</el-button
                >
              </div>
            </td>
            <td style="display: none"></td>
            <td style="display: none"></td>
            <td style="display: none"></td>
            <td style="display: none"></td>
            <td style="display: none"></td>
            <td style="display: none"></td>
          </tr>
          <tr>
            <td class="htCenter htMiddle htDimmed" rowspan="2" colspan="1">
              生产指标
            </td>
            <td class="htCenter htMiddle htDimmed" rowspan="2" colspan="1">
              计量单位
            </td>
            <td class="htCenter htMiddle htDimmed" rowspan="2" colspan="1">
              代码
            </td>
            <td class="htCenter htMiddle htDimmed" rowspan="1" colspan="2">
              本年
            </td>
            <td style="display: none"></td>
            <td class="htCenter htMiddle htDimmed" rowspan="1" colspan="2">
              去年同期
            </td>
            <td style="display: none"></td>
          </tr>
          <tr>
            <td style="display: none"></td>
            <td style="display: none"></td>
            <td style="display: none"></td>
            <td class="htCenter htDimmed">本月</td>
            <td class="htCenter htDimmed">1-本月</td>
            <td class="htCenter htDimmed">本月</td>
            <td class="htCenter htDimmed">1-本月</td>
          </tr>
          <tr
            v-for="(tb_zdjcqyczb1, index) in tb_zdjcqyczb1List"
            :key="index + 'a'"
          >
            <td>
              <el-cascader
                size="mini"
                style="width: 190px"
                :clearable="true"
                :options="hyOptions"
                :show-all-levels="false"
                @change="handleChange1(index)"
                v-model="tb_zdjcqyczb1.code_path"
                filterable
              ></el-cascader>
            </td>
            <td>
              <textarea
                tabindex="-1"
                class="handsontableInput"
                v-model="tb_zdjcqyczb1.unit"
              ></textarea>
            </td>
            <td>{{ tb_zdjcqyczb1.code }}</td>
            <td>
              <textarea
                tabindex="-1"
                class="handsontableInput"
                v-model="tb_zdjcqyczb1.month_this"
              ></textarea>
            </td>
            <td>
              <textarea
                tabindex="-1"
                class="handsontableInput"
                v-model="tb_zdjcqyczb1.month_this1"
              ></textarea>
            </td>
            <td>
              <textarea
                tabindex="-1"
                class="handsontableInput"
                v-model="tb_zdjcqyczb1.month_last"
              ></textarea>
            </td>
            <td>
              <textarea
                tabindex="-1"
                class="handsontableInput"
                v-model="tb_zdjcqyczb1.month_last1"
              ></textarea>
            </td>
          </tr>
          <tr>
            <td class="htCenter htDimmed" rowspan="1" colspan="7">
              主要工业产品产量
              <div style="float: right">
                <el-button
                  style="padding: 0px"
                  type="text"
                  size="mini"
                  :disabled="loading"
                  @click="addCpcl"
                  >添加</el-button
                >
              </div>
            </td>
            <td style="display: none"></td>
            <td style="display: none"></td>
            <td style="display: none"></td>
            <td style="display: none"></td>
            <td style="display: none"></td>
            <td style="display: none"></td>
          </tr>
          <tr>
            <td class="htCenter htMiddle htDimmed" rowspan="2" colspan="1">
              生产指标
            </td>
            <td class="htCenter htMiddle htDimmed" rowspan="2" colspan="1">
              计量单位
            </td>
            <td class="htCenter htMiddle htDimmed" rowspan="2" colspan="1">
              代码
            </td>
            <td class="htCenter htMiddle htDimmed" rowspan="1" colspan="2">
              本年
            </td>
            <td style="display: none"></td>
            <td class="htCenter htMiddle htDimmed" rowspan="1" colspan="2">
              去年同期
            </td>
            <td style="display: none"></td>
          </tr>
          <tr>
            <td style="display: none"></td>
            <td style="display: none"></td>
            <td style="display: none"></td>
            <td class="htCenter htDimmed">本月</td>
            <td class="htCenter htDimmed">1-本月</td>
            <td class="htCenter htDimmed">本月</td>
            <td class="htCenter htDimmed">1-本月</td>
          </tr>
          <tr
            v-for="(tb_zdjcqyczb2, index) in tb_zdjcqyczb2List"
            :key="index + 'b'"
          >
            <td>
              <el-cascader
                style="width: 190px"
                size="mini"
                :clearable="true"
                :options="cpOptions"
                :show-all-levels="false"
                @change="handleChange2(index)"
                v-model="tb_zdjcqyczb2.code_path"
                filterable
              ></el-cascader>
            </td>
            <td>{{ tb_zdjcqyczb2.unit }}</td>
            <td>{{ tb_zdjcqyczb2.code }}</td>
            <td>
              <textarea
                tabindex="-1"
                class="handsontableInput"
                v-model="tb_zdjcqyczb2.month_this"
              ></textarea>
            </td>
            <td>
              <textarea
                tabindex="-1"
                class="handsontableInput"
                v-model="tb_zdjcqyczb2.month_this1"
              ></textarea>
            </td>
            <td>
              <textarea
                tabindex="-1"
                class="handsontableInput"
                v-model="tb_zdjcqyczb2.month_last"
              ></textarea>
            </td>
            <td>
              <textarea
                tabindex="-1"
                class="handsontableInput"
                v-model="tb_zdjcqyczb2.month_last1"
              ></textarea>
            </td>
          </tr>
        </tbody>
      </table>
      <hot-table
        ref="hotTableComponent2"
        :width="width"
        :colWidths="colWidths"
        :height="height"
        :data="tb2"
        :mergeCells="mergeCells2"
        :cell="cell2"
        :licenseKey="licenseKey"
      ></hot-table>
      <div style="padding-top: 10px; text-align: center">
        <el-button type="primary" size="mini" :loading="loading" @click="cancel"
          >取消</el-button
        >
        <el-button type="primary" size="mini" :loading="loading" @click="apply"
          >申请</el-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import { HotTable } from "@handsontable/vue";
export default {
  name: "index",
  components: {
    HotTable,
  },
  props: {
    id: {
      type: String,
      required: true,
    },
    report_yidong: {
      type: Number,
      required: true,
    },
  },
  data: function () {
    return {
      loading: false,
      zdjcqyczb: {
        id: "",
        code: "",
        name: "",
        date_range: "",
        duty_person: "",
        duty_phone: "",
        create_time: null,
        doc_id: "",
        row: 1,
        month_query: "",
        year_query: "",
        quarter_query: "",
      },
      tb_zdjcqyczb0List: [],
      tb_zdjcqyczb1List: [],
      tb_zdjcqyczb2List: [],
      tb_zdjcqyczb3List: [],
      hyOptions: [],
      cpOptions: [],
      hydmList: [],
      cpList: [],
      fileList: [],

      colWidths: [200, 150, 150, 150, 150, 150, 150],
      width: 1100,
      height: 165,
      tb1: [],
      mergeCells1: [],
      cell1: [],
      tb2: [],
      mergeCells2: [],
      cell2: [],
      licenseKey: "non-commercial-and-evaluation",
    };
  },
  created() {
    this.init();
    this.getHyTree();
    this.getCpTree();
  },
  methods: {
    init() {
      const self = this;
      self.loading = true;
      //修改提交
      self.$axios
        .get("/business/data-insert/zdjcqyczb", {
          params: {
            id: self.id,
          },
        })
        .then((res) => {
          self.tb_zdjcqyczb0List = res.data.tb_zdjcqyczb0List;
          console.log(res.data);
          res.data.tb_zdjcqyczb1List.forEach((tb_zdjcqyczb1) => {
            tb_zdjcqyczb1.code_path = JSON.parse(tb_zdjcqyczb1.code_path);
            tb_zdjcqyczb1.code_path_name = JSON.parse(
              tb_zdjcqyczb1.code_path_name
            );
          });

          self.tb_zdjcqyczb1List = res.data.tb_zdjcqyczb1List;
          res.data.tb_zdjcqyczb2List.forEach((tb_zdjcqyczb2) => {
            tb_zdjcqyczb2.code_path = JSON.parse(tb_zdjcqyczb2.code_path);
            tb_zdjcqyczb2.code_path_name = JSON.parse(
              tb_zdjcqyczb2.code_path_name
            );
          });
          self.tb_zdjcqyczb2List = res.data.tb_zdjcqyczb2List;
          self.tb_zdjcqyczb3List = res.data.tb_zdjcqyczb3List;
          self.zdjcqyczb = res.data.zdjcqyczb;
          self.initTb1();
          self.initMergeCells1();
          self.initcell1();
          self.initTb2();
          self.initMergeCells2();
          self.initcell2();
          self.loading = false;
          console.log(res);
        })
        .catch((err) => {
          console.log("error", err);
          self.loading = false;
        });
    },
    initTb1() {
      const self = this;
      self.tb1 = [];
      self.tb1.push(["重点监测企业产值表", "", "", "", "", "", ""]);
      self.tb1.push([
        "组织机构代码：",
        self.zdjcqyczb.code,
        "",
        "",
        "",
        "",
        "",
      ]);
      self.tb1.push([
        "企业详细名称：",
        self.zdjcqyczb.name,
        "",
        "",
        "",
        "",
        "",
      ]);
      self.tb1.push([
        "生产指标：",
        "计量单位",
        "代码",
        "本年",
        "",
        "去年同期",
        "",
      ]);
      self.tb1.push(["", "", "", "本月", "1-本月", "本月", "1-本月"]);

      self.tb_zdjcqyczb0List.forEach((tb_zdjcqyczb0) => {
        self.tb1.push([
          tb_zdjcqyczb0.name,
          tb_zdjcqyczb0.unit,
          tb_zdjcqyczb0.code,
          tb_zdjcqyczb0.month_this,
          tb_zdjcqyczb0.month_this1,
          tb_zdjcqyczb0.month_last,
          tb_zdjcqyczb0.month_last1,
        ]);
      });
    },
    initMergeCells1() {
      const self = this;
      self.mergeCells1 = [];
      let row0 = { row: 0, col: 0, rowspan: 1, colspan: 7 };
      let row1 = { row: 1, col: 1, rowspan: 1, colspan: 6 };
      let row2 = { row: 2, col: 1, rowspan: 1, colspan: 6 };
      let row3_0 = { row: 3, col: 0, rowspan: 2, colspan: 1 };
      let row3_1 = { row: 3, col: 1, rowspan: 2, colspan: 1 };
      let row3_2 = { row: 3, col: 2, rowspan: 2, colspan: 1 };
      let row3_3 = { row: 3, col: 3, rowspan: 1, colspan: 2 };
      let row3_5 = { row: 3, col: 5, rowspan: 1, colspan: 2 };
      self.mergeCells1.push(row0);
      self.mergeCells1.push(row1);
      self.mergeCells1.push(row2);
      self.mergeCells1.push(row3_0);
      self.mergeCells1.push(row3_1);
      self.mergeCells1.push(row3_2);
      self.mergeCells1.push(row3_3);
      self.mergeCells1.push(row3_5);
    },
    initcell1() {
      const self = this;
      self.cell1 = [];
      self.cell1.push({
        row: 0,
        col: 0,
        className: "htCenter htMiddle",
        readOnly: true,
      });
      self.cell1.push({
        row: 1,
        col: 0,
        className: "htCenter htMiddle",
        readOnly: true,
      });
      self.cell1.push({
        row: 1,
        col: 1,
        className: "htLeft htMiddle",
        readOnly: true,
      });
      self.cell1.push({
        row: 2,
        col: 1,
        className: "htLeft htMiddle",
        readOnly: true,
      });
      self.cell1.push({
        row: 2,
        col: 0,
        className: "htCenter htMiddle",
        readOnly: true,
      });
      self.cell1.push({
        row: 3,
        col: 0,
        className: "htCenter htMiddle",
        readOnly: true,
      });
      self.cell1.push({
        row: 3,
        col: 1,
        className: "htCenter htMiddle",
        readOnly: true,
      });
      self.cell1.push({
        row: 3,
        col: 2,
        className: "htCenter htMiddle",
        readOnly: true,
      });
      self.cell1.push({
        row: 3,
        col: 3,
        className: "htCenter htMiddle",
        readOnly: true,
      });
      self.cell1.push({
        row: 3,
        col: 5,
        className: "htCenter htMiddle",
        readOnly: true,
      });
      self.cell1.push({
        row: 4,
        col: 3,
        className: "htCenter htMiddle",
        readOnly: true,
      });
      self.cell1.push({
        row: 4,
        col: 4,
        className: "htCenter htMiddle",
        readOnly: true,
      });
      self.cell1.push({
        row: 4,
        col: 5,
        className: "htCenter htMiddle",
        readOnly: true,
      });
      self.cell1.push({
        row: 4,
        col: 6,
        className: "htCenter htMiddle",
        readOnly: true,
      });
      self.cell1.push({
        row: 5,
        col: 0,
        className: "htCenter htMiddle",
        readOnly: true,
      });
      self.cell1.push({
        row: 5,
        col: 1,
        className: "htCenter htMiddle",
        readOnly: true,
      });
      self.cell1.push({
        row: 5,
        col: 2,
        className: "htCenter htMiddle",
        readOnly: true,
      });
      self.cell1.push({
        row: 6,
        col: 0,
        className: "htCenter htMiddle",
        readOnly: true,
      });
      self.cell1.push({
        row: 6,
        col: 1,
        className: "htCenter htMiddle",
        readOnly: true,
      });
      self.cell1.push({
        row: 6,
        col: 2,
        className: "htCenter htMiddle",
        readOnly: true,
      });

      self.cell1.push({
        row: 5,
        col: 3,
        className: "htCenter htMiddle",
        validator: self.validatorGyzczThis,
        type: "numeric",
        numericFormat: { pattern: "0.00" },
      });
      self.cell1.push({
        row: 5,
        col: 4,
        className: "htCenter htMiddle",
        validator: self.validatorGyzczThis1,
        type: "numeric",
        numericFormat: { pattern: "0.00" },
      });
      self.cell1.push({
        row: 5,
        col: 5,
        className: "htCenter htMiddle",
        type: "numeric",
        numericFormat: { pattern: "0.00" },
      });
      self.cell1.push({
        row: 5,
        col: 6,
        className: "htCenter htMiddle",
        validator: self.validatorGyzczLast1,
        type: "numeric",
        numericFormat: { pattern: "0.00" },
      });
      self.cell1.push({
        row: 6,
        col: 3,
        className: "htCenter htMiddle",
        validator: self.validatorGyxsczThis,
        type: "numeric",
        numericFormat: { pattern: "0.00" },
      });
      self.cell1.push({
        row: 6,
        col: 4,
        className: "htCenter htMiddle",
        validator: self.validatorGyxsczThis1,
        type: "numeric",
        numericFormat: { pattern: "0.00" },
      });
      self.cell1.push({
        row: 6,
        col: 5,
        className: "htCenter htMiddle",
        type: "numeric",
        numericFormat: { pattern: "0.00" },
      });
      self.cell1.push({
        row: 6,
        col: 6,
        className: "htCenter htMiddle",
        validator: self.validatorGyxsczLast1,
        type: "numeric",
        numericFormat: { pattern: "0.00" },
      });

      setTimeout(function () {
        self.$refs.hotTableComponent1.hotInstance.validateCells((valid) => {
          if (valid) {
            console.log(valid);
          }
        });
      }, 2000);
    },
    initTb2() {
      const self = this;
      self.tb2 = [];
      self.tb2.push(["补充资料", "", "", "", "", "", ""]);
      self.tb2.push([
        "生产指标：",
        "计量单位",
        "代码",
        "本年",
        "",
        "去年同期",
        "",
      ]);
      self.tb2.push(["", "", "", "本月", "1-本月", "本月", "1-本月"]);

      self.tb_zdjcqyczb3List.forEach((tb_zdjcqyczb3) => {
        self.tb2.push([
          tb_zdjcqyczb3.name,
          tb_zdjcqyczb3.unit,
          tb_zdjcqyczb3.code,
          tb_zdjcqyczb3.month_this,
          tb_zdjcqyczb3.month_this1,
          tb_zdjcqyczb3.month_last,
          tb_zdjcqyczb3.month_last1,
        ]);
      });
      self.tb2.push([
        "单位负责人",
        self.zdjcqyczb.duty_person,
        "",
        "联系电话",
        self.zdjcqyczb.duty_phone,
        "填报日期",
        self.zdjcqyczb.create_time,
      ]);
      self.tb2.push(["说明", self.zdjcqyczb.des, "", "", "", "", ""]);
    },
    initMergeCells2() {
      const self = this;
      self.mergeCells2 = [];
      let row0 = { row: 0, col: 0, rowspan: 1, colspan: 7 };
      let row1_0 = { row: 1, col: 0, rowspan: 2, colspan: 1 };
      let row1_1 = { row: 1, col: 1, rowspan: 2, colspan: 1 };
      let row1_2 = { row: 1, col: 2, rowspan: 2, colspan: 1 };
      let row1_3 = { row: 1, col: 3, rowspan: 1, colspan: 2 };
      let row1_5 = { row: 1, col: 5, rowspan: 1, colspan: 2 };
      let row5 = { row: 5, col: 1, rowspan: 1, colspan: 2 };
      let row6 = { row: 6, col: 1, rowspan: 1, colspan: 6 };
      self.mergeCells2.push(row0);
      self.mergeCells2.push(row1_0);
      self.mergeCells2.push(row1_1);
      self.mergeCells2.push(row1_2);
      self.mergeCells2.push(row1_3);
      self.mergeCells2.push(row1_5);
      self.mergeCells2.push(row5);
      self.mergeCells2.push(row6);
    },
    initcell2() {
      const self = this;
      self.cell2 = [];
      self.cell2.push({
        row: 0,
        col: 0,
        className: "htCenter htMiddle",
        readOnly: true,
      });
      self.cell2.push({
        row: 1,
        col: 0,
        className: "htCenter htMiddle",
        readOnly: true,
      });
      self.cell2.push({
        row: 1,
        col: 1,
        className: "htCenter htMiddle",
        readOnly: true,
      });
      self.cell2.push({
        row: 1,
        col: 2,
        className: "htCenter htMiddle",
        readOnly: true,
      });
      self.cell2.push({
        row: 1,
        col: 3,
        className: "htCenter htMiddle",
        readOnly: true,
      });
      self.cell2.push({
        row: 1,
        col: 5,
        className: "htCenter htMiddle",
        readOnly: true,
      });
      self.cell2.push({
        row: 2,
        col: 3,
        className: "htCenter htMiddle",
        readOnly: true,
      });
      self.cell2.push({
        row: 2,
        col: 4,
        className: "htCenter htMiddle",
        readOnly: true,
      });
      self.cell2.push({
        row: 2,
        col: 5,
        className: "htCenter htMiddle",
        readOnly: true,
      });
      self.cell2.push({
        row: 2,
        col: 6,
        className: "htCenter htMiddle",
        readOnly: true,
      });
      self.cell2.push({
        row: 3,
        col: 0,
        className: "htCenter htMiddle",
        readOnly: true,
      });
      self.cell2.push({
        row: 3,
        col: 1,
        className: "htCenter htMiddle",
        readOnly: true,
      });
      self.cell2.push({
        row: 3,
        col: 2,
        className: "htCenter htMiddle",
        readOnly: true,
      });
      self.cell2.push({
        row: 4,
        col: 0,
        className: "htCenter htMiddle",
        readOnly: true,
      });
      self.cell2.push({
        row: 4,
        col: 1,
        className: "htCenter htMiddle",
        readOnly: true,
      });
      self.cell2.push({
        row: 4,
        col: 2,
        className: "htCenter htMiddle",
        readOnly: true,
      });
      self.cell2.push({
        row: 5,
        col: 0,
        className: "htCenter htMiddle",
        readOnly: true,
      });
      self.cell2.push({
        row: 5,
        col: 3,
        className: "htCenter htMiddle",
        readOnly: true,
      });
      self.cell2.push({
        row: 5,
        col: 5,
        className: "htCenter htMiddle",
        readOnly: true,
      });
      self.cell2.push({
        row: 5,
        col: 6,
        className: "htCenter htMiddle",
        readOnly: true,
      });
      self.cell2.push({
        row: 6,
        col: 0,
        className: "htCenter htMiddle",
        readOnly: true,
      });

      self.cell2.push({
        row: 3,
        col: 3,
        className: "htCenter htMiddle",
        type: "numeric",
        numericFormat: { pattern: "0.00" },
      });
      self.cell2.push({
        row: 3,
        col: 4,
        className: "htCenter htMiddle",
        type: "numeric",
        numericFormat: { pattern: "0.00" },
      });
      self.cell2.push({
        row: 3,
        col: 5,
        className: "htCenter htMiddle",
        type: "numeric",
        numericFormat: { pattern: "0.00" },
      });
      self.cell2.push({
        row: 3,
        col: 6,
        className: "htCenter htMiddle",
        type: "numeric",
        numericFormat: { pattern: "0.00" },
      });
      self.cell2.push({
        row: 4,
        col: 3,
        className: "htCenter htMiddle",
        validator: self.validatorQyydlThis,
        type: "numeric",
        numericFormat: { pattern: "0.00" },
      });
      self.cell2.push({
        row: 4,
        col: 4,
        className: "htCenter htMiddle",
        validator: self.validatorQyydlThis1,
        type: "numeric",
        numericFormat: { pattern: "0.00" },
      });
      self.cell2.push({
        row: 4,
        col: 5,
        className: "htCenter htMiddle",
        type: "numeric",
        numericFormat: { pattern: "0.00" },
      });
      self.cell2.push({
        row: 4,
        col: 6,
        className: "htCenter htMiddle",
        validator: self.validatorQyydlLast1,
        type: "numeric",
        numericFormat: { pattern: "0.00" },
      });

      //
    },
    addZcz() {
      const self = this;
      self.tb_zdjcqyczb1List.push({
        id: "",
        code: "",
        code_path: [],
        code_path_name: [],
        name: "",
        unit: "",
      });
    },
    addCpcl() {
      const self = this;
      self.tb_zdjcqyczb2List.push({
        id: "",
        code: "",
        code_path: [],
        code_path_name: [],
        name: "",
        unit: "",
      });
    },
    handleChange1(index) {
      const self = this;
      let tb_zdjcqyczb1 = self.tb_zdjcqyczb1List[index];
      if (tb_zdjcqyczb1.code_path.length == 0) {
        console.log(index);
        self.tb_zdjcqyczb1List.splice(index, 1);
      } else {
        tb_zdjcqyczb1.code_path_name = [];
        tb_zdjcqyczb1.code_path.forEach((code) => {
          self.hydmList.forEach((hydm) => {
            if (code === hydm.code) {
              tb_zdjcqyczb1.code_path_name.push(hydm.name);
              tb_zdjcqyczb1.code = hydm.code;
              tb_zdjcqyczb1.name = hydm.name;
            }
          });
        });
      }
    },
    handleChange2(index) {
      const self = this;
      let tb_zdjcqyczb2 = self.tb_zdjcqyczb2List[index];
      if (tb_zdjcqyczb2.code_path.length == 0) {
        self.tb_zdjcqyczb2List.splice(index, 1);
      } else {
        tb_zdjcqyczb2.code_path_name = [];
        tb_zdjcqyczb2.code_path.forEach((code) => {
          self.cpList.forEach((cp) => {
            if (code === cp.code) {
              tb_zdjcqyczb2.code_path_name.push(cp.name);
              tb_zdjcqyczb2.code = cp.code;
              tb_zdjcqyczb2.name = cp.name;
              tb_zdjcqyczb2.unit = cp.unit;
            }
          });
        });
      }
    },
    //获取行业树
    getHyTree() {
      const self = this;
      self.$axios
        .get("/business/dm/hy/tree")
        .then((res) => {
          self.hydmList = res.data;
          self.hyOptions = self.toTree1(res.data, "-1");
        })
        .catch((res) => {
          console.log("行业树获取失败", res);
        });
    },
    //获取行业树
    getCpTree() {
      const self = this;
      self.$axios
        .get("/business/dm/cp/tree")
        .then((res) => {
          self.cpList = res.data;

          self.cpOptions = self.toTree(res.data, null);
        })
        .catch((res) => {
          console.log("产品树获取失败", res);
        });
    },
    toTree(treeData, parentId) {
      const self = this;
      const treeArr = [];
      for (let i = 0; i < treeData.length; i++) {
        const node = treeData[i];
        if (node.parent_code === parentId) {
          const newNode = {
            value: node.code,
            label: node.name,
          };
          let children = self.toTree(treeData, node.code);
          if (children.length > 0) {
            newNode["children"] = children;
          }
          treeArr.push(newNode);
        }
      }
      return treeArr;
    },
    toTree1(treeData, parentId) {
      const self = this;
      const treeArr = [];
      treeData.map((item, i) => {
        const newNode = {
          value: item.code,
          label: item.name,
        };
        treeArr.push(newNode);
      });
      console.log("treeArr", treeArr);
      return treeArr;
    },
    apply() {
      const self = this;
      self.loading = true;
      self.zdjcqyczb.duty_person = self.$refs.hotTableComponent2.hotInstance.getDataAtCell(
        5,
        1
      );
      self.zdjcqyczb.duty_phone = self.$refs.hotTableComponent2.hotInstance.getDataAtCell(
        5,
        4
      );
      self.zdjcqyczb.des = self.$refs.hotTableComponent2.hotInstance.getDataAtCell(
        6,
        1
      );

      self.tb1.forEach((item) => {
        self.tb_zdjcqyczb0List.forEach((tb_zdjcqyczb0) => {
          if (item[0] == tb_zdjcqyczb0.name) {
            tb_zdjcqyczb0.month_this = item[3];
            tb_zdjcqyczb0.month_this1 = item[4];
            tb_zdjcqyczb0.month_last = item[5];
            tb_zdjcqyczb0.month_last1 = item[6];
          }
        });
      });

      self.tb2.forEach((item) => {
        self.tb_zdjcqyczb3List.forEach((tb_zdjcqyczb3) => {
          if (item[0] == tb_zdjcqyczb3.name) {
            tb_zdjcqyczb3.month_this = item[3];
            tb_zdjcqyczb3.month_this1 = item[4];
            tb_zdjcqyczb3.month_last = item[5];
            tb_zdjcqyczb3.month_last1 = item[6];
          }
        });
      });

      const data = {
        zdjcqyczb: self.zdjcqyczb,
        tb_zdjcqyczb0List: self.tb_zdjcqyczb0List,
        tb_zdjcqyczb1List: self.tb_zdjcqyczb1List,
        tb_zdjcqyczb2List: self.tb_zdjcqyczb2List,
        tb_zdjcqyczb3List: self.tb_zdjcqyczb3List,
      };
      this.$axios
        .post("/business/data-insert/zdjcqyczb/edit-apply", data)
        .then((res) => {
          this.$emit("clos");
          self.loading = false;
        })
        .catch((error) => {
          console.log(error);
          self.loading = false;
        });
    },
    edit() {
      const self = this;
      self.loading = true;
      self.zdjcqyczb.duty_person = self.$refs.hotTableComponent2.hotInstance.getDataAtCell(
        5,
        1
      );
      self.zdjcqyczb.duty_phone = self.$refs.hotTableComponent2.hotInstance.getDataAtCell(
        5,
        4
      );
      self.zdjcqyczb.des = self.$refs.hotTableComponent2.hotInstance.getDataAtCell(
        6,
        1
      );

      self.tb1.forEach((item) => {
        self.tb_zdjcqyczb0List.forEach((tb_zdjcqyczb0) => {
          if (item[0] == tb_zdjcqyczb0.name) {
            tb_zdjcqyczb0.month_this = item[3];
            tb_zdjcqyczb0.month_this1 = item[4];
            tb_zdjcqyczb0.month_last = item[5];
            tb_zdjcqyczb0.month_last1 = item[6];
          }
        });
      });

      self.tb2.forEach((item) => {
        self.tb_zdjcqyczb3List.forEach((tb_zdjcqyczb3) => {
          if (item[0] == tb_zdjcqyczb3.name) {
            tb_zdjcqyczb3.month_this = item[3];
            tb_zdjcqyczb3.month_this1 = item[4];
            tb_zdjcqyczb3.month_last = item[5];
            tb_zdjcqyczb3.month_last1 = item[6];
          }
        });
      });
      const data = {
        zdjcqyczb: self.zdjcqyczb,
        tb_zdjcqyczb0List: self.tb_zdjcqyczb0List,
        tb_zdjcqyczb1List: self.tb_zdjcqyczb1List,
        tb_zdjcqyczb2List: self.tb_zdjcqyczb2List,
        tb_zdjcqyczb3List: self.tb_zdjcqyczb3List,
      };
      this.$axios
        .post("/business/data-insert/zdjcqyczb/edit", data)
        .then((res) => {
          this.$emit("clos");
          self.loading = false;
        })
        .catch((error) => {
          console.log(error);
          self.loading = false;
        });
    },
    cancel() {
      this.$emit("clos");
    },
    downLoadExcel() {
      window.open(
        window.location.origin +
          "/api/business/data-insert/zdjcqyczb/download-template?id=" +
          this.id
      );
    },
    handleRemove(file, fileList) {
      this.fileList = fileList;
    },
    handleExceed() {
      this.$message.warning(`当前限制选择 1 个文件`);
    },
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },
    onChange(file, fileList) {
      const self = this;
      self.fileList = fileList;
      self.loading = true;
      const formdata = new FormData();
      formdata.append("file", this.fileList[0].raw);
      formdata.append("id", self.id);
      self.$axios
        .post("/business/data-insert/zdjcqyczb/upload", formdata)
        .then((res) => {
          self.fileList = [];
          self.$message.success("上传成功");
          self.loading = false;
          self.init();
        })
        .catch((err) => {
          self.loading = false;
          self.init();
          console.log("error", err);
        });
    },
    validatorGyzczThis(value, callback) {
      //工业总产值本年本月
      const self = this;
      if (self.report_yidong) {
        return callback(true);
      } else if (!/^[0-9]+\.?[0-9]*$/.test(value)) {
        return callback(false);
      }
      const gyzczThis = value; //工业总产值本年本月;
      const gyxsczThis = self.$refs.hotTableComponent1.hotInstance.getDataAtCell(
        6,
        3
      ); //工业销售产值本年本月;
      const gyzczThis1 = self.$refs.hotTableComponent1.hotInstance.getDataAtCell(
        5,
        4
      ); //工业总产值本年1-本月;
      const message = "您所填的工业销售产值大于工业总产值!";
      const message1 =
        "您所填的工业总产值：本年本月大于 工业总产值：本年1-本月!";
      setTimeout(function () {
        if (gyxsczThis > gyzczThis) {
          self.$message.warning(message);
          callback(false);
        } else if (gyzczThis > gyzczThis1) {
          self.$message.warning(message1);
          callback(false);
        } else {
          callback(true);
        }
      }, 1000);
    },
    validatorGyxsczThis(value, callback) {
      //工业销售产值本年本月
      const self = this;
      if (self.report_yidong) {
        return callback(true);
      } else if (!/^[0-9]+\.?[0-9]*$/.test(value)) {
        return callback(false);
      }
      const gyxsczThis = value; //工业销售产值本年本月;
      const gyxsczThis1 = self.$refs.hotTableComponent1.hotInstance.getDataAtCell(
        6,
        4
      ); //工业销售产值本年1-本月
      const gyzczThis = self.$refs.hotTableComponent1.hotInstance.getDataAtCell(
        5,
        3
      ); //工业总产值本年本月;
      const message = "您所填的工业销售产值大于工业总产值!";
      const message1 =
        "您所填的工业销售产值：本年本月大于 工业销售产值：本年1-本月!";
      setTimeout(function () {
        if (gyxsczThis > gyzczThis) {
          self.$message.warning(message);
          callback(false);
        } else if (gyxsczThis > gyxsczThis1) {
          self.$message.warning(message1);
          callback(false);
        } else {
          callback(true);
        }
      }, 1000);
    },
    validatorGyzczThis1(value, callback) {
      //业总产值本年1-本月
      const self = this;
      if (self.report_yidong) {
        return callback(true);
      } else if (!/^[0-9]+\.?[0-9]*$/.test(value)) {
        return callback(false);
      }
      const gyzczThis1 = value; //业总产值本年1-本月;
      const gyzczLast1 = self.$refs.hotTableComponent1.hotInstance.getDataAtCell(
        5,
        6
      ); //上年同期工业总产值：本年1-本月;
      const gyzczThis = self.$refs.hotTableComponent1.hotInstance.getDataAtCell(
        5,
        3
      ); //工业总产值本年本月;
      const message =
        "您所填的工业总产值：本年本月大于 工业总产值：本年1-本月!";
      const message1 = "您的工业总产值：本年1-本月高于去年值30%!";
      setTimeout(function () {
        if (gyzczThis > gyzczThis1) {
          self.$message.warning(message);
          callback(false);
        } else if (gyzczThis1 > gyzczLast1 * 1.3) {
          self.$message.warning(message1);
          callback(false);
        } else {
          callback(true);
        }
      }, 1000);
    },
    validatorGyxsczThis1(value, callback) {
      //工业销售产值本年1-本月
      const self = this;
      if (self.report_yidong) {
        return callback(true);
      } else if (!/^[0-9]+\.?[0-9]*$/.test(value)) {
        return callback(false);
      }
      const gyxsczThis1 = value; //工业销售产值本年1-本月
      const gyxsczLast1 = self.$refs.hotTableComponent1.hotInstance.getDataAtCell(
        6,
        6
      ); //上年同期工业销售产值：本年1-本月
      const gyxsczThis = self.$refs.hotTableComponent1.hotInstance.getDataAtCell(
        6,
        3
      ); //工业销售产值本年本月;
      const message =
        "您所填的工业销售产值：本年本月大于 工业销售产值：本年1-本月!";
      const message1 = "您的工业销售产值：本年1-本月高于去年值30%!";
      setTimeout(function () {
        if (gyxsczThis > gyxsczThis1) {
          self.$message.warning(message);
          callback(false);
        } else if (gyxsczThis1 > gyxsczLast1 * 1.3) {
          self.$message.warning(message1);
          callback(false);
        } else {
          callback(true);
        }
      }, 1000);
    },
    validatorQyydlThis(value, callback) {
      //企业用电量：本年本月
      const self = this;
      if (self.report_yidong) {
        return callback(true);
      } else if (!/^[0-9]+\.?[0-9]*$/.test(value)) {
        return callback(false);
      }
      const qyydlThis = value; //企业用电量：本年本月
      const qyydlThis1 = self.$refs.hotTableComponent2.hotInstance.getDataAtCell(
        4,
        4
      ); //企业用电量：本年1-本月;
      const message = "您所填的企业用电量：本年本月大于企业用电量：本年1-本月!";
      setTimeout(function () {
        if (qyydlThis > qyydlThis1) {
          self.$message.warning(message);
          callback(false);
        } else {
          callback(true);
        }
      }, 1000);
    },
    validatorQyydlThis1(value, callback) {
      //企业用电量：本年1-本月;
      const self = this;
      if (self.report_yidong) {
        return callback(true);
      } else if (!/^[0-9]+\.?[0-9]*$/.test(value)) {
        return callback(false);
      }
      const qyydlThis1 = value; //企业用电量：本年1-本月;
      const qyydlLast1 = self.$refs.hotTableComponent2.hotInstance.getDataAtCell(
        4,
        6
      ); //上年同期企业用电量：本年1-本月
      const qyydlThis = self.$refs.hotTableComponent2.hotInstance.getDataAtCell(
        4,
        3
      ); //企业用电量：本年本月;
      const message = "您所填的企业用电量：本年本月大于企业用电量：本年1-本月!";
      const message1 = "企业用电量：本年1-本月高于去年值30%!";
      setTimeout(function () {
        if (qyydlThis > qyydlThis1) {
          self.$message.warning(message);
          callback(false);
        } else if (qyydlThis1 > qyydlLast1 * 1.3) {
          self.$message.warning(message1);
          callback(false);
        } else {
          callback(true);
        }
      }, 1000);
    },
    validatorGyzczLast1(value, callback) {
      //上年同期工业总产值：本年1-本月;
      const self = this;
      if (self.report_yidong) {
        return callback(true);
      } else if (!/^[0-9]+\.?[0-9]*$/.test(value)) {
        return callback(false);
      }
      const gyzczLast1 = value; //上年同期工业总产值：本年1-本月;
      const gyzczThis1 = self.$refs.hotTableComponent1.hotInstance.getDataAtCell(
        5,
        4
      ); //业总产值本年1-本月;
      const message = "您的工业总产值：本年1-本月高于去年值30%!";
      setTimeout(function () {
        if (gyzczThis1 > gyzczLast1 * 1.3) {
          self.$message.warning(message);
          callback(false);
        } else {
          callback(true);
        }
      }, 1000);
    },
    validatorGyxsczLast1(value, callback) {
      //上年同期工业销售产值：本年1-本月
      const self = this;
      if (self.report_yidong) {
        return callback(true);
      } else if (!/^[0-9]+\.?[0-9]*$/.test(value)) {
        return callback(false);
      }
      const gyxsczLast1 = value; //上年同期工业销售产值：本年1-本月
      const gyxsczThis1 = self.$refs.hotTableComponent1.hotInstance.getDataAtCell(
        6,
        6
      ); //工业销售产值本年1-本月
      const message = "您的工业销售产值：本年1-本月高于去年值30%!";
      setTimeout(function () {
        if (gyxsczThis1 > gyxsczLast1 * 1.3) {
          self.$message.warning(message);
          callback(false);
        } else {
          callback(true);
        }
      }, 1000);
    },
    validatorQyydlLast1(value, callback) {
      //上年同期企业用电量：本年1-本月
      const self = this;
      if (self.report_yidong) {
        return callback(true);
      } else if (!/^[0-9]+\.?[0-9]*$/.test(value)) {
        return callback(false);
      }
      const qyydlLast1 = value; //上年同期企业用电量：本年1-本月
      const qyydlThis1 = self.$refs.hotTableComponent2.hotInstance.getDataAtCell(
        4,
        4
      ); //企业用电量：本年1-本月;
      const message = "企业用电量：本年1-本月高于去年值30%!";
      setTimeout(function () {
        if (qyydlThis1 > qyydlLast1 * 1.3) {
          self.$message.warning(message);
          callback(false);
        } else {
          callback(true);
        }
      }, 1000);
    },
  },
};
</script>
<style>
#hot-14j0b5t .handsontableInput {
  box-shadow: 0 0 0 0 #f6f7f8 inset;
  padding: 0px;
}

#hot-14j0b5t textarea {
  padding: 0px;
  width: 891px;
  height: 20px;
  font-size: 15px;
  font-family: PingFang SC;
  resize: none;
  min-width: 891px;
  max-width: 1641px;
  overflow-y: hidden;
}

#hot-14j0b5t .el-cascader.el-cascader--mini {
  height: 20px;
}
#hot-14j0b5t .el-input.el-input--mini.el-input--suffix {
  height: 20px;
}

#hot-14j0b5t .el-input__inner {
  height: 20px;
  border: 0px;
  padding: 0px;
}

#hot-14j0b5t .wtHolder {
  overflow: hidden;
}
</style>